fx.ns("models", class ProductMedia extends fx.Model {

	constructor(data)
	{
        super(data);
    }

});